var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconConfidentiality(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48.007,
    height: 49,
    viewBox: "0 0 48.007 49",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "payment",
    transform: "translate(-0.111 0.528)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "payment-2",
    "data-name": "payment",
    transform: "translate(0 -0.082)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6824",
    "data-name": "Group 6824"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_1211",
    "data-name": "Ellipse 1211",
    cx: 24,
    cy: 24.5,
    rx: 24,
    ry: 24.5,
    transform: "translate(0.111 -0.446)",
    fill: "#53b3cb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15056",
    "data-name": "Path 15056",
    d: "M168.166,85.186c0-.967-6.336-7.008-9.34-9.648l-9.975.543-4.741-3.839-4.263.531-8.393,19.765,6.382,16.424a24.167,24.167,0,0,0,30.329-23.776Z",
    transform: "translate(-120.048 -61.29)",
    fill: "#3f9eb5"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "shield_1_",
    "data-name": "shield (1)",
    transform: "translate(9.189 6.297)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15067",
    "data-name": "Path 15067",
    d: "M69.193,6.525V16.548A19.94,19.94,0,0,1,54.139,35.878,19.936,19.936,0,0,1,39.1,16.548V6.525C46.061,5.74,50,3.092,54.146,0,58.289,3.092,62.232,5.74,69.193,6.525Z",
    transform: "translate(-39.1)",
    fill: "#ffd15c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15068",
    "data-name": "Path 15068",
    d: "M101.744,90.723A16.115,16.115,0,0,1,90.5,75.351V68.56a30.511,30.511,0,0,0,11.244-5.06,29.835,29.835,0,0,0,11.244,5.067v6.791A16.112,16.112,0,0,1,101.744,90.723Z",
    transform: "translate(-86.698 -58.803)",
    fill: "#f8b64c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15069",
    "data-name": "Path 15069",
    d: "M162.406,192.978l-3.706-3.706,1.879-1.886,1.827,1.82,6.813-6.806,1.879,1.879Z",
    transform: "translate(-149.853 -168.907)",
    fill: "#fff"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconConfidentiality);
export default __webpack_public_path__ + "static/media/icon-confidentiality.6fb34cbf.svg";
export { ForwardRef as ReactComponent };